var path = '/var/www/mmscny-cms/src/app/components/trip-planning/trip-planning.html';
var html = "<content-template details=$ctrl.details is-overview-exist=false disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-submit=$ctrl.onSubmit()> </content-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trip-planning/trip-planning.html
// module id = 800
// module chunks = 0